const state = {
  MapInstance: null,
  Geocoder: null,
  AutocompleteService: null,
  PlacesService: null,
  CurrentMarker: null,
  ShowGoogleMapsModal: false
};

const actions = {
  loadGoogleMapsApiScript(context) {
    const API_KEY = "AIzaSyBpvuJAjGtiSzZ1o0eXS11aVT7Jq3isWyU"; // TODO: Get this from API
    let mapsScript = document.getElementById("googleMapsApiScript");

    // If Google Maps API script is already loaded, return
    //if (mapsScript) return;

    mapsScript = document.createElement("script");
    mapsScript.setAttribute("id", "googleMapsApiScript");
    mapsScript.setAttribute("type", "text/javascript");
    mapsScript.setAttribute("async", true);
    mapsScript.setAttribute("defer", true);

    mapsScript.src = `https://maps.googleapis.com/maps/api/js?key=${API_KEY}&libraries=places`;
    mapsScript.onload = () => {
      // console.log("Google Maps API loaded");
      const kansasCity = new google.maps.LatLng(39.10108, -94.58525);
      const map = new google.maps.Map(
        document.getElementById("rootGoogleMap"),
        {
          center: kansasCity,
          zoom: 15
        }
      );
      context.commit("setMapInstance", map);
    };

    const bodyElements = document.getElementsByTagName("body");
    if (bodyElements && bodyElements.length > 0)
      bodyElements[0].append(mapsScript);
  },
  openAddressOnGoogleMaps(context, address) {
    return new Promise((resolve, reject) => {
      state.Geocoder.geocode({ address: address }, function(results, status) {
        if (status != google.maps.places.PlacesServiceStatus.OK || !results) {
          console.error(status);
          return reject(false);
        }

        // Remove any previous marker placed on the map
        if (state.CurrentMarker) state.CurrentMarker.setMap(null);

        state.MapInstance.setCenter(results[0].geometry.location);
        const marker = new google.maps.Marker({
          map: state.MapInstance,
          position: results[0].geometry.location
        });
        context.commit("updateCurrentMarker", marker);
        context.commit("toggleGoogleMapsModal", true);
        resolve(true);
      });
    });
  },
  searchPlaces(context, searchText) {
    return new Promise((resolve, reject) => {
      // TODO: Use session token for billing
      state.AutocompleteService.getPlacePredictions(
        {
          input: searchText
        },
        function(predictions, status) {
          if (status != google.maps.places.PlacesServiceStatus.OK) {
            console.error(status);
            return reject(status);
          }

          if (predictions && predictions.length > 0) {
            console.log(predictions[0]);
            context.dispatch("getPlaceDetails", predictions[0].place_id);
          }

          resolve(predictions);
        }
      );
    });
  },
  getPlaceDetails(context, placeId) {
    return new Promise((resolve, reject) => {
      // TODO: Use session token for billing
      state.PlacesService.getDetails(
        {
          placeId: placeId
        },
        function(place, status) {
          if (status != google.maps.places.PlacesServiceStatus.OK) {
            alert(status);
            return;
          }

          console.log(place);

          // TODO: Convert from Google Maps address to AutoAlert address
          // API Reference: https://developers.google.com/maps/documentation/javascript/geocoding#GeocodingAddressTypes
          context.dispatch("openAddressOnGoogleMaps", place.formatted_address);
        }
      );
    });
  },
  closeGoogleMapsModal(context) {
    context.commit("toggleGoogleMapsModal", false);
  }
};

const mutations = {
  setMapInstance(state, map) {
    state.MapInstance = map;
    state.Geocoder = new google.maps.Geocoder();
    state.AutocompleteService = new google.maps.places.AutocompleteService();
    state.PlacesService = new google.maps.places.PlacesService(
      state.MapInstance
    );
  },
  toggleGoogleMapsModal(state, value) {
    state.ShowGoogleMapsModal = value;
  },
  updateCurrentMarker(state, marker) {
    state.CurrentMarker = marker;
  }
};

export default {
  state,
  actions,
  mutations
};



// WEBPACK FOOTER //
// ./src/store/modules/GoogleMaps.js